<script>
    export let title = "title";

    export let imageLink = "https://via.placeholder.com/150";
    export let price = 0;
    export let priceFormatted = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(price);
</script>

<div class="card">
    <div class="card-header">
        <div class="card-title">
            <div class="title">{title}</div>
        </div>
    </div>
    <div class="card-content">
        <div class="card-img">
            <!-- svelte-ignore a11y-img-redundant-alt -->
            <img src={imageLink} alt="card-image" />
        </div>
        <div class="price">{priceFormatted}</div>
        <div class="card-content-text">Average Repair Cost</div>
    </div>
</div>

<style>
    .card {
        @apply bg-surface-100 border-surface-300  w-full h-full;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        min-width: 220px;
        min-height: 100%;
        justify-content: space-between;
        align-items: center;
        margin: auto;
        box-shadow: 0px 0px 30px 0px #00000026;

        /* flex-grow: 1 !important; */
    }

    .card-header {
        @apply w-full;
    }

    .card-title {
        @apply w-full;
    }

    .title {
        @apply text-primary-500;
        margin: 0 0 0.5rem 0;

        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    }

    .card-content {
        @apply w-full;
    }

    .card-img {
        @apply w-full;
        display: flex;
        max-height: 100px;
        padding: 0 1rem;
        justify-content: center;
    }

    .card-img img {
        @apply w-full;
        max-height: 100px;
        justify-content: center;
        object-fit: cover;
        margin: auto;
        border-radius: 20px;
        box-shadow: 0px 0px 30px 0px #00000026;
        filter: saturate(0.5);
    }

    .card-content-text {
        @apply text-lg;
        padding: 0 1rem;
        margin: 1rem 0;
        text-align: center;
        line-height: 2rem;
    }

    .price {
        @apply text-3xl font-semibold text-left text-secondary-500;
        line-height: 1rem;

        margin: 1.5rem 0 1rem 0;
        padding: 0 1rem;
    }
</style>
